import { Switch, Route, useRouteMatch } from "react-router-dom";
// import DetalleChecklist from "./detalle-checklist";
import ReportesScreen from "./index";
import ConsolidadoRespuestas from "./consolidado-respuestas/consolidado-respuestas";

const RouterReportes = () => {
  // console.log('RouterDashboard');
  const { path } = useRouteMatch();
  // console.log(path);
  return (
    // <LayoutUsuario>
    <Switch>
      <Route exact path={`${path}`}>
        <ReportesScreen />
      </Route>

      <Route path={`${path}/consolidado-respuestas/consolidado-respuestas`}>
        <ConsolidadoRespuestas />
      </Route>

      {/*<Route path={`${path}/usuario-web`}>
          <UsuarioWeb />
        </Route> */}

    </Switch>
    // </LayoutUsuario>
  );
};

export default RouterReportes;
